function JudgeMeWidgetFactory(container) {
  class JudgeMeWidget {
    constructor(container, customerEmail, customerFirstName, customerLastName) {
      this.judgeMeWidget = container;
      this.rating = this.judgeMeWidget
        .querySelector("[data-average-rating")
        .getAttribute("data-average-rating");
      this.reviewsAmount = this.judgeMeWidget
        .querySelector("[data-number-of-reviews")
        .getAttribute("data-number-of-reviews");

      this._init();
    }
    appendHtml(selector, htmlContent, position = "beforeend") {
      const div = selector;
      if (div) {
        div.insertAdjacentHTML(position, htmlContent);
      } else {
        console.warn(`Element with selector "${selector}" not found.`);
      }
    }

    _init() {
      this._renderCustomElements();
    }
    _renderCustomElements() {
      this.appendHtml(
        this.judgeMeWidget.querySelector(".jdgm-rev-widg"),
        `<h2 class="jdgm-rev-widg__section-title">
          ${window.themeVariables.translations.reviews.title}
        </h2>`,
        "afterbegin"
      );
      this.appendHtml(
        this.judgeMeWidget.querySelector(".jdgm-rev-widg__summary"),
        `<p class="jdgm-rev-widg__summary-rating">${this.rating}</p>`,
        "afterbegin"
      );
      this.appendHtml(
        this.judgeMeWidget.querySelector(".jdgm-widget-actions-wrapper"),
        `<p class="jdgm-widget-actions--disclaimer">
            ${window.themeVariables.translations.reviews.disclaimer}
            <a href="#">${window.themeVariables.translations.reviews.disclaimer_cta}</a>
        </p>`,
        "beforeend"
      );
      this.appendHtml(
        this.judgeMeWidget.querySelector('[data-rating="5"]'),
        `<div class="jdgm-histogram__star-count">
            5
        </div>`,
        "afterbegin"
      );
      this.appendHtml(
        this.judgeMeWidget.querySelector('[data-rating="4"]'),
        `<div class="jdgm-histogram__star-count">
            4
        </div>`,
        "afterbegin"
      );
      this.appendHtml(
        this.judgeMeWidget.querySelector('[data-rating="3"]'),
        `<div class="jdgm-histogram__star-count">
            3
        </div>`,
        "afterbegin"
      );
      this.appendHtml(
        this.judgeMeWidget.querySelector('[data-rating="2"]'),
        `<div class="jdgm-histogram__star-count">
            2
        </div>`,
        "afterbegin"
      );
      this.appendHtml(
        this.judgeMeWidget.querySelector('[data-rating="1"]'),
        `<div class="jdgm-histogram__star-count">
            1
        </div>`,
        "afterbegin"
      );

      //   for (const filterToggler of this.filterTogglers) {
      //     filterToggler.addEventListener("click", () => {
      //       this.judgeMeWidget.classList.toggle("--active");
      //     });
      //   }
    }
  }
  return new JudgeMeWidget(container);
}
